<template>
  <v-card outlined class="report-section-card mb-3">
    <v-card-text class="pa-4">
      <div>
        <div class="section-title">Purchase</div>
        <div class="section-subtitle">Purchase and vendor reports</div>
      </div>

      <div class="report-list mt-3">
        <div class="report-item" @click="openDateSelector('purchase/byDate')">
          <div class="report-icon-box"><v-img src="@/assets/Report/tax.png" /></div>
          <div class="report-item-title">Purchase By Date</div>
          <v-icon color="#94a3b8">mdi-calendar-range</v-icon>
        </div>

        <div class="report-item" @click="openReport('vendor')">
          <div class="report-icon-box"><v-img src="@/assets/Report/buyer.png" /></div>
          <div class="report-item-title">Vendor List</div>
          <v-icon color="#94a3b8">mdi-chevron-right</v-icon>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "report-purchase",

  methods: {
    ...mapActions("reportView", ["setDateSelector", "setReportName"]),

    openReport(link) {
      const routeData = this.$router.resolve({ path: `/reportView/purchase/${link}` });
      window.open(routeData.href, "_blank");
    },

    openDateSelector(reportName) {
      this.setReportName(reportName);
      this.setDateSelector(true);
    },
  },
};
</script>

<style scoped>
.report-section-card { border-radius: 20px; background: #ffffff; }
.section-title { font-size: 18px; font-weight: 800; color: #0f172a; }
.section-subtitle { font-size: 13px; color: #64748b; margin-top: 2px; }
.report-list { display: grid; gap: 8px; }
.report-item { display: flex; align-items: center; gap: 12px; padding: 12px; border-radius: 16px; background: #f8fafc; cursor: pointer; transition: 0.2s ease; }
.report-item:hover { background: #eef2ff; }
.report-icon-box { width: 38px; height: 38px; min-width: 38px; border-radius: 12px; background: #ffffff; padding: 7px; display: flex; align-items: center; justify-content: center; }
.report-item-title { flex: 1; font-size: 14px; font-weight: 700; color: #0f172a; }
</style>
